import Vue from 'vue';
import App from './App.vue';
import './plugins/vuetify';
import router from './router';
import store from '@/store';
var VueCookie = require ('vue-cookie');
import DEFINES from '@/defines';
import i18n from './i18n';
import moment from 'moment';
import VueClipboard from 'vue-clipboard2';
import Chat from 'vue-beautiful-chat';
import VueGooglePlaces from 'vue-google-places';
require('@/plugins/firebase')
import VueCardFormat from 'vue-credit-card-validation';
import baseApi from './api/_baseApi';

import { getInitialTheme, applyThemeCSS, applyThemeClass } from './utils/themeLoader';

const themeTheory = getInitialTheme();
applyThemeClass(themeTheory);
applyThemeCSS(themeTheory);


var momentTz = require ('moment-timezone');
//Google analytics configuration for production env
require ('./analytics');

// Vue Filters
import filters from './filter';
Vue.use (VueGooglePlaces);
Vue.use (Chat);
Vue.use (VueClipboard);
Vue.use (VueCookie);
Vue.use (momentTz);


import Print from 'vue-print-nb'
Vue.use(Print);

// Vue Tooltip
import VTooltip from 'v-tooltip';
import "@/plugins/tooltip.scss";
Vue.use(VTooltip);

// Lib to validate credit card details
Vue.use (VueCardFormat);

Vue.prototype.DEFINES = DEFINES;
Vue.prototype.moment = moment;
Vue.config.productionTip = false;
Vue.prototype.momentTz = momentTz;
Vue.prototype.$baseApi = baseApi


new Vue ({
  router,
  store,
  i18n,
  render: h => h (App)
}).$mount ('#app');
